import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { TransportService } from 'src/app/services/Transport/transport.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-print-student-transport-opt-report',
  templateUrl: './print-student-transport-opt-report.component.html',
  styleUrls: ['./print-student-transport-opt-report.component.css']
})
export class PrintStudentTransportOptReportComponent implements OnInit {

  constructor(private activatedRoute:ActivatedRoute,private transportService:TransportService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) {

    this.activatedRoute.queryParams.subscribe(params => {
     
      this.SearchFilter.ClassID =  params['ClassID'];
      this.SearchFilter.SectionID =  params['SectionID'];
      this.SearchFilter.RouteID =  params['RouteID'];
      this.SearchFilter.RouteLocationID =  params['RouteLocationID'];
      this.SearchFilter.StudentNo =  params['StudentNo'];
      this.DisplayModel.Route = decodeURIComponent(params['Route']);
      this.DisplayModel.Location = decodeURIComponent(params['Location']);
      this.DisplayModel.StudentNo = this.SearchFilter.StudentNo ;
      this.DisplayModel.Class = decodeURIComponent(params['Class']);
      this.DisplayModel.Section = decodeURIComponent(params['Section']);
      this.GetAllTransportOptReport()
  });
   }
   DisplayModel = {
    Route: '',
    Location: '',
    StudentNo: '',
    Class: '',
    Section: '',
}
  SearchFilter = {
    ClassID: 0,
    SectionID: 0,
    RouteID: 0,
    RouteLocationID: 0,
    StudentNo:'',
}
SubmittedFilter = false;
AllTransportOptReportList = [];


loading = false;
InstallmentList:any;
BranchDetails:any;
inst=0;
GetAllTransportOptReport  () {
    this.SubmittedFilter = true;
    this.spinnerService.show();      
        
        this.transportService.GetAllTransportOptReport(JSON.stringify(this.SearchFilter)).subscribe( (response)=> {
            this.AllTransportOptReportList = response.AllTransportOptReportList;
            this.InstallmentList = response.InstallmentList;
            this.BranchDetails = response.BranchDetails;
            this.globalHelper.CheckActionStatus(response);
             this.inst=this.InstallmentList.length;
            this.spinnerService.hide(); 
            setTimeout( () =>{
              window.print();
          }, 100);
        });
    
}




  ngOnInit() {
   ;
  }

}

